import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import { Button } from "semantic-ui-react";
import classNames from "classnames";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { VerticalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";
import { getSortedAccessTypes, GuestlistAccessFilterType, initialAccessFilter } from "./FilterTypes/GuestlistAccessFilterType";
import { getGuestlistAccessTypeText } from "utilities/enumutils";

interface Props {
  initialAccessTypes: server.dto.GuestlistAccessType[]
}

const GuestlistAccessFilter = (props: Props) => {
  const reset = (): GuestlistAccessFilterType => ({
    selectedAccessTypes: [],
    initialAccessTypes: props.initialAccessTypes
  });

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("guestlistAccessTypes", {
    getTitle: () => RESX.Guestlist.AccessType,
    renderSelection: (filter) => {
      return <div className="flex flex-wrap">
        {getSortedAccessTypes(filter).map((at, index) =>
          <React.Fragment key={at.guestlistAccessTypeId}>
            {getGuestlistAccessTypeText(at)}
            {index !== filter.selectedAccessTypes.length - 1 && <span className="padding-right">,</span>}
          </React.Fragment>
        )}
      </div>;
    },
    hasValue: (filter) => {
      return filter.selectedAccessTypes.length > 0;
    },
    reset,
    areEqual: (a, b) => {
      return areArrayValuesEqual(a.selectedAccessTypes.map(s => s.guestlistAccessTypeId), b.selectedAccessTypes.map(s => s.guestlistAccessTypeId));
    }
  });
  useEffect(() => {
    setInitialValue("guestlistAccessTypes", reset());
  }, []);

  const [selectedAccessTypes, setSelectedAccessTypes] = React.useState<server.dto.GuestlistAccessType[]>(initialAccessFilter.selectedAccessTypes);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedAccessTypes(getValue("guestlistAccessTypes").selectedAccessTypes);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    if (selectedAccessTypes.length > 0) {
      setValue("guestlistAccessTypes", {
        selectedAccessTypes,
        initialAccessTypes: props.initialAccessTypes ?? []
      });
    } else {
      setValue("guestlistAccessTypes", reset());
    }
    setPopupOpen(false);
  };

  const onToggle = (accessType: server.dto.GuestlistAccessType) => {
    if (selectedAccessTypes.some(at => at.guestlistAccessTypeId === accessType.guestlistAccessTypeId)) {
      setSelectedAccessTypes(selectedAccessTypes.filter(at => at.guestlistAccessTypeId !== accessType.guestlistAccessTypeId));
    } else {
      setSelectedAccessTypes([...selectedAccessTypes, accessType]);
    }
  };

  const selectedAccessTypeSet = new Set(selectedAccessTypes.map(s => s.guestlistAccessTypeId));

  return <div>
    <FilterPopup
      filterButtonLabel={RESX.Guestlist.AccessType}
      content={<form onSubmit={onApply}>
        <div className={classNames("flex-column gap-small margin-bottom scrollbox-auto")} style={{ maxHeight: 300 }}>
          {props.initialAccessTypes.map(accessType => (
            <Checkbox
              key={accessType.guestlistAccessTypeId}
              keyboardNavigationOptions={VerticalKeyboardNavigationGroup("accessType")}
              onChange={() => onToggle(accessType)}
              checked={selectedAccessTypeSet.has(accessType.guestlistAccessTypeId)}
              label={getGuestlistAccessTypeText(accessType)}
            />
          ))}
        </div>

        <div>
          <Button primary fluid type="submit">{RESX.SelectionManager.Apply}</Button>
        </div>

      </form>}
      width={300}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default GuestlistAccessFilter;
